export type Role = 'sender' | 'receiver';

export type WaitingSpeaker = { id: string; name: string; admitted: boolean; reconnecting: boolean };

export type SignalingMessage =
  | { type: 'HELLO'; role: Role; name?: string; clientId: string; live?: boolean }
  | { type: 'PEER_LEFT'; role: Role; peer?: string; final?: boolean }
  | { type: 'OFFER'; sdp: string; peer?: string }
  | { type: 'ANSWER'; sdp: string; peer?: string }
  | { type: 'ICE'; candidate: RTCIceCandidateInit; peer?: string }
  | { type: 'BYE' }
  | { type: 'ROSTER'; speakers: WaitingSpeaker[] }
  | { type: 'ADMIT'; speakerId: string }
  | { type: 'DISCONNECT'; speakerId: string }
  | { type: 'KICK'; speakerId: string }
  | { type: 'ADMITTED' }
  | { type: 'RESUMED' }
  | { type: 'DISMISSED' }
  | { type: 'KICKED' }
  | { type: 'ROOM_FULL' }
  | { type: 'TAKE_START'; takeId: string; projectId: string; uploadKey: string; uploadToken: string; peer?: string }
  | { type: 'TAKE_STOP'; takeId: string; peer?: string }
  | { type: 'TAKE_REUPLOAD'; takeId: string; uploadKey: string; uploadToken: string; peer?: string }
  | { type: 'TAKE_UPLOADED'; takeId: string; ok: boolean; startSeq?: number; error?: string; peer?: string };

const KNOWN_TYPES = new Set([
  'HELLO', 'PEER_LEFT', 'OFFER', 'ANSWER', 'ICE', 'BYE',
  'ROSTER', 'ADMIT', 'DISCONNECT', 'KICK', 'ADMITTED', 'RESUMED', 'DISMISSED', 'KICKED', 'ROOM_FULL',
  'TAKE_START', 'TAKE_STOP', 'TAKE_REUPLOAD', 'TAKE_UPLOADED',
]);

export function parseMessage(raw: string): SignalingMessage {
  const obj = JSON.parse(raw);
  if (!obj || typeof obj !== 'object' || typeof obj.type !== 'string' || !KNOWN_TYPES.has(obj.type)) {
    throw new Error(`unknown signaling message: ${raw.slice(0, 100)}`);
  }
  return obj as SignalingMessage;
}

export function serializeMessage(msg: SignalingMessage): string {
  return JSON.stringify(msg);
}
